import { ReactNode } from "react";
import { useEffect, useState } from "react";
import { useLocation } from "@tanstack/react-router";
export interface Props {
  children: ReactNode;
  translucentEffect: boolean;
}
const HOME_PATHS = new Set(["/", "/vivame", "/black-friday", "/natal"]);

const WrapperHeader = ({ children, translucentEffect }: Props) => {
  const [scroll, setScroll] = useState(
    typeof window !== "undefined" ? window.scrollY : 0,
  );
  const pathname = useLocation({ select: (location) => location.pathname });
  const isHome = HOME_PATHS.has(pathname);

  function debounceScroll(callback: () => void, delay = 100) {
    let timeout: ReturnType<typeof setTimeout> | undefined;

    return () => {
      clearTimeout(timeout);
      timeout = setTimeout(callback, delay);
    };
  }

  const onScroll = debounceScroll(() => {
    setScroll(globalThis.scrollY);
  });

  useEffect(() => {
    globalThis.addEventListener("scroll", onScroll);

    return () => {
      globalThis.removeEventListener("scroll", onScroll);
    };
  }, []);

  return (
    <div
      className={`
            ${isHome ? "isHome" : "notHome"}
            ${scroll !== 0 ? "scrollOn" : "scrollOff"}
            ${
        isHome && translucentEffect && scroll == 0
          ? "translucent-true"
          : "translucent-false"
      }
            `}
    >
      {children}
    </div>
  );
};
export default WrapperHeader;
